/**
 * Initializes Vue components.
 */
// Init Vue.
import Vue from 'vue';

window.Vue = Vue;

$(() => {
    // Init vue app.
    window.vueApp = new Vue({
        el: '.vue-app'
    });
});
